<div class="backpage-wrapper">
  <div class="individual-sub-container">
    <div class="header">
      <h1>Zentra Subscription Overview</h1>
    </div>
    <div class="top-2-section">
      <div class="customer-section">
        <div class="section-header">
          <mat-icon>person</mat-icon>
          <h3>Customer Information</h3>
        </div>
        <div class="customer-section-content">
          <div class="site-name">
            <h4>Customer Name</h4>
            <p>
              {{ subscriptionDetail?.subscription?.customer?.firstName }}
              {{ subscriptionDetail?.subscription?.customer?.lastName }}
            </p>
          </div>
          @if (subscriptionDetail?.subscription?.customer?.organization) {
          <div class="site-name">
            <h4>Company</h4>
            <p>
              {{ subscriptionDetail?.subscription?.customer?.organization }}
            </p>
          </div>
          }
          <div class="property-address">
            <h4>Email</h4>
            <p>{{ subscriptionDetail?.subscription?.customer?.email }}</p>
          </div>
          <div class="property-info">
            <h4>Phone</h4>
            <p>
              {{
                subscriptionDetail?.subscription?.customer?.phone ||
                  "Not Available"
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="property-section">
        <div class="section-header">
          <mat-icon>business</mat-icon>
          <h3>Property Information</h3>
        </div>
        <div class="property-section-content">
          <div class="site-name">
            <h4>Property/Site Name</h4>
            <p>{{ getMetaFieldValue("property_name") }}</p>
          </div>
          <div class="property-address">
            <h4>Property Address</h4>
            <!-- <p>
              {{ getMetaFieldValue("property_address") }}
            </p>
            <p>
              {{ getMetaFieldValue("property_city") }},
              {{ getMetaFieldValue("property_state") }}
              {{ getMetaFieldValue("property_zip") }}
            </p> -->
            <p>{{ getFormattedPropertyAddress() }}</p>
          </div>
          <div class="property-info">
            <h4>Property Manager Info</h4>
            <div class="info-row">
              <div class="info-item">
                <p class="label">Name</p>
                <p class="value">
                  {{ getMetaFieldValue("property_manager_f_name") }}
                  {{ getMetaFieldValue("property_manager_l_name") }}
                </p>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <p class="label">Email</p>
                <p class="value">
                  {{ getMetaFieldValue("property_manager_email") }}
                </p>
              </div>
              <div class="info-item">
                <p class="label">Phone</p>
                <p class="value">
                  {{ getMetaFieldValue("property_manager_phone") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- middle -->
    <div class="middle-2-section">
      <div class="customer-section">
        <div class="section-header">
          <mat-icon>assignment</mat-icon>
          <h3>Plan Details</h3>
        </div>
        <div class="customer-section-content">
          <div class="site-name">
            <h4>Product Name</h4>
            <p>{{ subscriptionDetail?.subscription?.product?.name }}</p>
            <h4>Components</h4>
            <div
              *ngFor="
                let component of subscriptionDetail?.subscriptionComponents
              "
            >
              <p>{{ component.name }}: {{ component.allocatedQuantity }}</p>
            </div>
            <ng-container
              *ifPermissions="['!Subscription View For GuestPurchaser']"
            >
              @if (getMetaFieldValue('po_number') !== 'N/A') {
              <h4>PO Number</h4>
              <p>{{ getMetaFieldValue("po_number") }}</p>
              }
            </ng-container>
          </div>
        </div>
      </div>
      <div class="payment-section">
        <div class="section-header-payment">
          <div class="left-aligned">
            <mat-icon>attach_money</mat-icon>
            <h3>Payment Method</h3>
          </div>
          <button
            mat-button
            class="submit-ticket-button"
            [disabled]="!subscriptionDetail?.subscription?.customer?.id"
            (click)="navigateToUpdatePaymentPage()"
          >
            Add New Payment Method
          </button>
        </div>

        <div class="payment-section-content">
          <div class="site-name">
            <h4>Payment Info</h4>

            <!-- Display Credit Card Info if available -->
            <div *ngIf="subscriptionDetail?.subscription?.creditCard">
              <p>
                Card Number:
                {{
                  subscriptionDetail.subscription.creditCard.maskedCardNumber
                }}
              </p>
              <p>
                Name on Card:
                {{ subscriptionDetail.subscription.creditCard.firstName }}
                {{ subscriptionDetail.subscription.creditCard.lastName }}
              </p>
              <p>
                Expiration Date:
                {{
                  subscriptionDetail.subscription.creditCard.expirationMonth
                }}/{{
                  subscriptionDetail.subscription.creditCard.expirationYear
                }}
              </p>
            </div>

            <!-- Display ACH (Bank Account) Info if available -->
            <div *ngIf="subscriptionDetail?.subscription?.bankAccount">
              <p>
                Bank Name:
                {{ subscriptionDetail.subscription.bankAccount.bankName }}
              </p>
              <p>
                Account Number:
                {{
                  subscriptionDetail.subscription.bankAccount
                    .maskedBankAccountNumber
                }}
              </p>
              <p>
                Routing Number:
                {{
                  subscriptionDetail.subscription.bankAccount
                    .maskedBankRoutingNumber
                }}
              </p>
            </div>

            <!-- Fallback if neither Credit Card nor ACH is available -->
            <div
              *ngIf="
                !subscriptionDetail?.subscription?.creditCard &&
                !subscriptionDetail?.subscription?.bankAccount
              "
            >
              <p>No payment method information available.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Invoice-container">
      <div class="invoice-section">
        <div class="section-header-payment">
          <div class="left-aligned">
            <mat-icon>receipt</mat-icon>
            <h3>Invoices</h3>
          </div>
        </div>
        <div class="invoice-section-content">
          <div class="site-name">
            <mat-table
              *ngIf="subscriptionDetail?.subscriptionInvoices?.invoices"
              [dataSource]="subscriptionDetail.subscriptionInvoices.invoices"
            >
              <!-- Invoice Number Column -->
              <ng-container matColumnDef="number">
                <mat-header-cell *matHeaderCellDef>
                  Invoice Number
                </mat-header-cell>
                <mat-cell *matCellDef="let invoice">
                  #{{ invoice.number }}
                </mat-cell>
              </ng-container>

              <!-- Issued At Column -->
              <ng-container matColumnDef="issueDate">
                <mat-header-cell *matHeaderCellDef> Issued At </mat-header-cell>
                <mat-cell *matCellDef="let invoice">
                  {{ invoice.issueDate | date: "MM/dd/yyyy" }}
                </mat-cell>
              </ng-container>

              <!-- Due Date Column -->
              <ng-container matColumnDef="dueDate">
                <mat-header-cell *matHeaderCellDef> Due Date </mat-header-cell>
                <mat-cell *matCellDef="let invoice">
                  {{ invoice.dueDate | date: "MM/dd/yyyy" }}
                </mat-cell>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
                <mat-cell *matCellDef="let invoice">
                  <mat-chip
                    [ngClass]="getStatusClass(invoice.status)"
                    selected
                    color="primary"
                  >
                    {{ getInvoiceStatus(invoice.status) }}
                  </mat-chip>
                </mat-cell>
              </ng-container>

              <!-- Total Amount Column -->
              <ng-container matColumnDef="totalAmount">
                <mat-header-cell *matHeaderCellDef>
                  Total Amount
                </mat-header-cell>
                <mat-cell *matCellDef="let invoice">
                  {{ invoice.totalAmount | currency }}
                </mat-cell>
              </ng-container>

              <!-- Amount Due Column -->
              <ng-container matColumnDef="dueAmount">
                <mat-header-cell *matHeaderCellDef>
                  Amount Due
                </mat-header-cell>
                <mat-cell *matCellDef="let invoice">
                  <div class="cell-content">
                    <span>{{ invoice.dueAmount | currency }}</span>
                    <button
                      mat-icon-button
                      color="accent"
                      (click)="openInvoice(invoice.publicUrl)"
                      [disabled]="!invoice.publicUrl"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </div>
                </mat-cell>
              </ng-container>

              <!-- Define Header and Data Rows -->
              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
              ></mat-row>
            </mat-table>
          </div>
        </div>
      </div>
    </div>
    <div class="middle-2-section">
      <div class="property-section">
        <div class="section-header">
          <mat-icon>today</mat-icon>
          <h3>Important Dates</h3>
        </div>
        <div class="property-section-content">
          <div class="site-name">
            <h4>Start Date</h4>
            <p>
              {{
                subscriptionDetail.subscription.currentPeriodStartedAt
                  | date: "MM/dd/yyyy"
              }}
            </p>
          </div>
          <div class="property-address">
            <h4>Billing Renewal Date</h4>
            <ng-container *ngIf="!isOneTimeProduct; else oneTimeMsg">
              <p>
                {{
                  subscriptionDetail.subscription.currentPeriodEndsAt
                    | date: "MM/dd/yyyy"
                }}
              </p>
            </ng-container>
            <ng-template #oneTimeMsg>
              <p>Non‑recurring — one time fee</p>
            </ng-template>
          </div>
        </div>
      </div>
      <ng-container *ngIf="(wholesalers || []).length > 0">
        <div class="property-section">
          <div class="section-header-payment">
            <div class="left-aligned">
              <mat-icon>business_center</mat-icon>
              <h3>Wholesaler Information</h3>
            </div>
            <ng-container *ngIf="wholesalers.length > 1">
              <button
                mat-button
                class="submit-ticket-button"
                (click)="updateWholesaler()"
              >
                Update Wholesaler
              </button></ng-container
            >
          </div>
          <div class="property-section-content">
            <div class="site-name">
              <h4>Current Wholesaler</h4>
              <ng-container
                *ngIf="
                  subscriptionDetail.currentWholesalerDetails;
                  else noCurrentWholesaler
                "
              >
                <div class="wholesaler-card">
                  <div class="wholesaler-company">
                    <mat-icon>business</mat-icon>
                    <span>{{
                      subscriptionDetail.currentWholesalerDetails?.userCompany
                    }}</span>
                  </div>
                  <div class="wholesaler-contact">
                    <span class="wholesaler-contact-label">Invited by</span>
                    <div class="wholesaler-contact-item">
                      <mat-icon>person</mat-icon>
                      <span
                        >{{
                          subscriptionDetail.currentWholesalerDetails
                            ?.userFirstName
                        }}
                        {{
                          subscriptionDetail.currentWholesalerDetails
                            ?.userLastName
                        }}</span
                      >
                    </div>
                    <div class="wholesaler-contact-item">
                      <mat-icon>email</mat-icon>
                      <span>{{
                        subscriptionDetail.currentWholesalerDetails?.userEmail
                      }}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #noCurrentWholesaler>
                <p>No wholesaler associated</p>
              </ng-template>
            </div>
            <div
              class="site-name"
              *ngIf="getMetaFieldValue('reference_po') !== 'N/A'"
            >
              <h4>Reference PO</h4>
              <p>{{ getMetaFieldValue("reference_po") }}</p>
            </div>
            <div
              class="site-name"
              *ngIf="
                subscriptionDetail.futureWholesalerDetails &&
                subscriptionDetail.futureWholesalerDetails?.userEmail !==
                  subscriptionDetail.currentWholesalerDetails?.userEmail
              "
            >
              <h4>Future Wholesaler (Effective at Renewal)</h4>
              <div class="wholesaler-card">
                <div class="wholesaler-company">
                  <mat-icon>business</mat-icon>
                  <span>{{
                    subscriptionDetail.futureWholesalerDetails?.userCompany
                  }}</span>
                </div>
                <div class="wholesaler-contact">
                  <span class="wholesaler-contact-label">Invited by</span>
                  <div class="wholesaler-contact-item">
                    <mat-icon>person</mat-icon>
                    <span
                      >{{
                        subscriptionDetail.futureWholesalerDetails
                          ?.userFirstName
                      }}
                      {{
                        subscriptionDetail.futureWholesalerDetails
                          ?.userLastName
                      }}</span
                    >
                  </div>
                  <div class="wholesaler-contact-item">
                    <mat-icon>email</mat-icon>
                    <span>{{
                      subscriptionDetail.futureWholesalerDetails?.userEmail
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="property-address">
              <p>
                *Note: Updating Wholesaler will go into effect at next renewal
                date.*
              </p>
              <ng-template #oneTimeMsg>
                <p>Non‑recurring — one time fee</p>
              </ng-template>
            </div> -->
          </div>
        </div>
      </ng-container>
    </div>
    <div class="cancel-container">
      <button
        mat-button
        class="backsubs-button"
        [routerLink]="['/all-subscriptions']"
      >
        <mat-icon>arrow_back</mat-icon>Back
      </button>
      <button mat-button class="cancel-button" (click)="openCancelDialog()">
        Cancel Subscription
      </button>
    </div>
  </div>
</div>
